import { useEffect } from 'react';

import AnimatedContent from '@tb-core/components/behavior/animated-content';
import DeliveryLogos from '@tb-core/components/delivery/styled/delivery-logos';
import Heading from '@tb-core/components/simple/heading';
import PageTitle from '@tb-core/components/simple/page-title';
import BrandedLinkButton from '@tb-core/components/styled/links/branded-link-button';
import ContentfulRichText from '@tb-core/components/ui/contentful-rich-text';
// temporary way to pull animation data for static builds/exports
// make sure to add GeneralError_SadTaco-Animation.json to core/src/data
import animationData from '@tb-core/data/GeneralError_SadTaco-Animation.json';
import { updateDataLayer } from '@tb-core/helpers/analytics/google';
import { entriesByTypename } from '@tb-core/helpers/content';
import usePageContext from '@tb-core/hooks/use-page-context';
import { LinkProps } from '@tb-core/types';
import VisitorPrioritizationLogo from '@tb/components/visitor-prioritization-logo';

import styles from './styles.scss';

const VisitorPrioritizationMain = () => {
    useEffect(() => {
        updateDataLayer({ pageTitle: 'Visitor Prioritization Page' });
    }, []);
    const {
        content: { pageData }
    } = usePageContext();
    const {
        description,
        entriesCollection: { items },
        title: pageTitle
    } = pageData.contentGroupCollection?.items[0];
    const {
        entriesCollection: linklogocollection,
        title: deliveryTitle
    } = pageData.contentGroupCollection?.items[1];
    // can't destructure AnimatedContent as TS will confuse it with the AnimatedContent component
    const { Link } = entriesByTypename(items);
    const { Image } = entriesByTypename(items);
    const pageLogo = Image && Image[0];
    // @todo this will be fixed later via a different ticket
    // const animatedContent = items.filter(
    //     content => content.id === 'visitor-prioritization-sad-taco-animation'
    // )[0];
    // ctaLink is the Contentful Link object
    const ctaLink = Link && Link[0];

    return (
        <main className={styles.main}>
            {pageLogo && <VisitorPrioritizationLogo src={pageLogo.src} />}
            <PageTitle className={styles.title}>{pageTitle}</PageTitle>
            <div className={styles['mascot-description-container']}>
                <div className={styles['mascot-container']}>
                    {/* TODO: make sure animation data is being pulled from contentful, this method is just for static builds/export */}
                    <AnimatedContent loop={true} src={animationData} />
                </div>
                <div className={styles['description-container']}>
                    {description?.json && (
                        <div className={styles.description}>
                            <ContentfulRichText node={description.json} />
                        </div>
                    )}

                    {ctaLink && (
                        <BrandedLinkButton
                            className={styles.cta}
                            gaDataLayerConfig={{
                                'Analytics-Action':
                                    'Visitor Prioritization > CTA Click',
                                'Analytics-Value': ctaLink.label
                            }}
                            href={ctaLink.url}
                        >
                            {ctaLink.label}
                        </BrandedLinkButton>
                    )}
                </div>
            </div>
            <Heading tag="h2" className={styles['delivery-title']}>
                {deliveryTitle}
            </Heading>
            <div className={styles['delivery-logos']}>
                <DeliveryLogos
                    links={linklogocollection.items as LinkProps[]}
                />
            </div>
        </main>
    );
};

export default VisitorPrioritizationMain;
